import React, { useState, useEffect, useContext } from "react";
import { ModalContext } from "components/ModalContext";

import { useDispatch, useSelector } from "react-redux";
import { updateFilter, setTemplateAction } from "store/actions/filter";
import {addSelectItems, updateTable} from "store/actions/table";
import { updateCategory } from "utils/builder/IScheduleLogic";
import { useDashboardState } from "components/DashboardContext";
import "./SidebarProject.scss";

import UniversalButton from "components/uiComponents/UniversalButton";
import RadioListModal from "components/modals/RadioListModal";
import SaveTemplateModals from "components/modals/SaveTemplateModals";
import SidebarButtonDropdown from "components/sidebarComponents/SidebarButtonDropdown";
import SidebarDropdown from "components/sidebarComponents/SidebarDropdown";
import GoToPremiumModal from "components/modals/GoToPremiumModal";
import Tag from "components/uiComponents/Tag";
import ModalComponent from "../../modals/ModalComponent";

import { ReactComponent as TemplateIcon } from 'static/icons/settings-template.svg';
import { checkPremium } from "../../../utils/helpers";

const select = {
    categories: null,
    filterValues: null,
    groups: null,
    properties: null,
    secondFilter: null,
};

const initState = {
    categories: [],
    properties: [],
    group: [],
};

const SidebarProject = () => {
    const dispatch = useDispatch();
    const { handleModal } = useContext(ModalContext);

    const [selectionState, setSelectionState] = useState(select);
    const [filterState, setFilterState] = useState(initState);
    const [isPremiumModalVisible, setPremiumModalVisible] = useState(false);
    const [isOpenInitialDropdown, setInitDropdownIsOpen] = useState(null);


    const {
        properties,
        selection,
        templates,
        template,
        commonCategories,
        uncommonCategories,
        commonProperties,
        uncommonProperties,
        commonGroupingOptions,
        uncommonGroupingOptions,
        templatesFolder
    } = useSelector((state) => state.viewer);

    const { subscreption } = useSelector((state) => state.user.info);

    const IS_PREMIUM = checkPremium(subscreption);

    const {
        setIsTableHidden,
        isModalLoaded,
        setIsModalLoaded,
    } = useDashboardState();

    //(Guy) ugly way to solve keeping the previous selection, should be changed
    if (selectionState.properties == null && properties != null) {
        selectionState.properties = [];
        var lists = document.getElementsByClassName("list_1");
        if (lists != null && lists.length > 0) {
            var proplist = lists[lists.length - 1];
            if (proplist.children != null) {
                var checkboxes = proplist.children;
                for (var i = 0; i < checkboxes.length; i++) {
                    if (properties.includes(checkboxes[i].outerText) && checkboxes[i].control.checked)
                        selectionState.properties.push(checkboxes[i].outerText);
                }
            }
        }
    }

    if (selectionState.groups == null && properties != null) {
        selectionState.groups = [];
        var lists = document.getElementsByClassName("items-list");
        if (lists != null && lists.length > 0) {
            var groupList = lists[0];
            if (groupList.children != null) {
                var groups = groupList.children;
                for (var i = 0; i < groups.length; i++) {
                    if (properties.includes(groups[i].outerText))
                        selectionState.groups.push(groups[i].outerText);
                }
            }
        }
    }

    const dispatchFilters = (callback, type, ...data) => {

        dispatch(
            updateFilter(
                () => callback(...data),
                type
            )
        );
    };

    useEffect(() => {
        if (selection) {
            setSelectionState(selection);
        } else {
            setSelectionState(select);
        }
    }, [selection]);

    useEffect(() => {
        if (isModalLoaded.status) {
            setIsModalLoaded({ status: false });

            handleClearOptions('categories');
        }
    }, [isModalLoaded])

    useEffect(() => {
        setFilterState((prevState) => {
            if (template) {
                return {
                    ...prevState,
                    categories: selectionState.categories ? selectionState.categories : [],
                    properties: selectionState.properties ? selectionState.properties : [],
                    group: selectionState.groups ? selectionState.groups : [],
                };
            } else {
                const newCategories = [...prevState.categories];

                selectionState?.categories?.forEach(item => {
                    if (!newCategories.some(category => category === item)) {
                        newCategories.push(item)
                    }
                });

                return {
                    ...prevState,
                    categories: newCategories,
                };
            }
        });
    }, [
        selectionState?.categories,
        selectionState?.properties,
        selectionState?.groups,
    ]);

    const handleCloseModal = () => {
        handleModal(null, true);
    };

    const handleChangeTemplate = (template, folder) => {
        dispatch(setTemplateAction(template, folder))
            .then(() => {
                setIsTableHidden(false);
            });
    };

    const handleLoadSearchTemplate = () => {

        handleModal(
            <RadioListModal
                options={templates}
                templatesFolder={templatesFolder}
                selectedOption={template}
                title="Templates"
                closeModal={handleCloseModal}
                onChangeTemplate={handleChangeTemplate}
                handleOpenPremiumModal={handleOpenPremiumModal}
                subscreption={IS_PREMIUM}
            />
        );
    };
    const handleSaveTemplateModals = () => {

      handleModal(
        <SaveTemplateModals filterState={filterState}/>
      );
    };

    const handleChangeOptions = (option, optionsType) => {
        const currentOptions = [...filterState[optionsType]];
        const currentOptionIndex = currentOptions.findIndex(item => item === option);

        if (currentOptionIndex > -1) {
            currentOptions.splice(currentOptionIndex, 1);
        } else {
            currentOptions.push(option);
        }

        if (optionsType === 'categories') {
            dispatchFilters(updateCategory, "CATEGORY", currentOptions);

            if (!currentOptions.length) {
                setFilterState(initState);
            } else {
                setFilterState({
                    ...filterState,
                    [optionsType]: currentOptions,
                });
            }
        } else {
            setFilterState({
                ...filterState,
                [optionsType]: currentOptions,
            });
        }
    };

    const handleClearOptions = (optionsType) => {
        if (filterState?.[optionsType]?.length) {
            if (optionsType === 'categories') {
                dispatchFilters(updateCategory, "CATEGORY", []);
                setFilterState(initState);
            } else {
                setFilterState({
                    ...filterState,
                    [optionsType]: [],
                });
            }
        }
    };

    const handleCreateReport = async () => {
        dispatch(addSelectItems({selectItems: {}, id: 1}));
        await dispatch(updateTable(filterState.properties, filterState.group));

        setIsTableHidden(false);
    };

    const handleClosePremiumModal = () => {
      setPremiumModalVisible(false);
    };

    const handleOpenPremiumModal = () => {
      handleCloseModal();
      setPremiumModalVisible(true);
    };

    const scroll = () => {
      setInitDropdownIsOpen(!isOpenInitialDropdown);
    }

  const handleRemoveTag = (option, settingParameter) => {
    const currentOptions = [...filterState[settingParameter]];
    const currentOptionIndex = currentOptions.findIndex(item => item === option);

    if (currentOptionIndex > -1) {
      currentOptions.splice(currentOptionIndex, 1);
    }

    if(settingParameter === "categories") {
      dispatchFilters(updateCategory, "CATEGORY", currentOptions);

      if (currentOptions.length) {
        setFilterState({
          ...filterState,
          categories: currentOptions,
        });
      } else {
        setFilterState({
          ...filterState,
          categories: [],
          properties: [],
          group: [],
        });
      }
    } else {
      setFilterState({
        ...filterState,
        [settingParameter]: currentOptions,
      });
    }
  };

    return (
        <div className="sidebar-project__container">

            <div className="sidebar-project">
                <div className="sidebar-project__header">Search</div>
                <UniversalButton
                    label="Load search template"
                    size="lg"
                    labelColor="blue"
                    labelHoverColor="blue"
                    backgroundColor="white"
                    backgroundHoverColor="blue-light"
                    borderColor="gray2"
                    borderHoverColor="gray2"
                    isFullWidth
                    leftIcon={<TemplateIcon className="search-template__icon" />}
                    onClick={handleLoadSearchTemplate}
                />

                <p className="sidebar-project__section_title">
                    Search Settings
                </p>
                <div className="sidebar-project__button-dropdown-wrapper" onScroll={scroll}>
                  <div className="sidebar-project__button-dropdown-wrapper_scroll">
                    <div className="sidebar-project__button-dropdown_container">
                      <SidebarButtonDropdown
                        label="Category"
                        buttonTitle="Select categories"
                        buttonBorder
                        dropdownPosition="right"
                        isFullHeight
                        optionsType="categories"
                        onClearAll={handleClearOptions}
                        isOpenInitialDropdown={isOpenInitialDropdown}
                      >
                        <SidebarDropdown
                          optionsType="categories"
                          commonOptions={commonCategories}
                          uncommonOptions={uncommonCategories}
                          selectedItems={filterState?.categories}
                          onChangeSelectedItems={handleChangeOptions}
                        />
                      </SidebarButtonDropdown>
                    </div>

                    <div className="sidebar-project__tags_container">
                      {
                        filterState?.categories?.map(option => {

                          return (
                            <Tag
                              key={option}
                              title={option}
                              onRemoveTag={() => handleRemoveTag(option, "categories")}
                            />
                          );
                        })
                      }
                    </div>

                    <div className="sidebar-project__button-dropdown_container">
                      <SidebarButtonDropdown
                        label="Table parameters"
                        buttonTitle="Select parameters"
                        buttonBorder
                        dropdownPosition="right"
                        isFullHeight
                        optionsType="properties"
                        onClearAll={handleClearOptions}
                        isOpenInitialDropdown={isOpenInitialDropdown}
                      >
                        <SidebarDropdown
                          optionsType="properties"
                          commonOptions={commonProperties}
                          uncommonOptions={uncommonProperties}
                          selectedItems={filterState?.properties}
                          onChangeSelectedItems={handleChangeOptions}

                        />
                      </SidebarButtonDropdown>
                    </div>

                    <div className="sidebar-project__tags_container">
                      {
                        filterState?.properties?.map(option => {

                          return (
                            <Tag
                              key={option}
                              title={option}
                              onRemoveTag={() => handleRemoveTag(option, "properties")}
                            />
                          );
                        })
                      }
                    </div>

                    <div className="sidebar-project__button-dropdown_container">
                      <SidebarButtonDropdown
                        label="Organize by"
                        buttonTitle="Select groups"
                        buttonBorder
                        dropdownPosition="right"
                        isFullHeight
                        optionsType="group"
                        onClearAll={handleClearOptions}
                        isOpenInitialDropdown={isOpenInitialDropdown}
                      >
                        <SidebarDropdown
                          optionsType="group"
                          commonOptions={commonGroupingOptions}
                          uncommonOptions={uncommonGroupingOptions}
                          selectedItems={filterState?.group}
                          onChangeSelectedItems={handleChangeOptions}
                        />
                      </SidebarButtonDropdown>
                    </div>

                    <div className="sidebar-project__tags_container">
                      {
                        filterState?.group?.map(option => {

                          return (
                            <Tag
                              key={option}
                              title={option}
                              onRemoveTag={() => handleRemoveTag(option, "group")}
                            />
                          );
                        })
                      }
                    </div>
                  </div>
                </div>
            </div>

            <div className="sidebar-module__footer">
                <UniversalButton
                    style={{marginBottom: '10px'}}
                    label="Save as template"
                    size="lg"
                    labelColor="blue"
                    labelHoverColor="blue"
                    backgroundColor="blue"
                    backgroundHoverColor="$blue"
                    isFullWidth
                    premium={!IS_PREMIUM}
                    onClick={!IS_PREMIUM ? handleOpenPremiumModal : handleSaveTemplateModals}
                />
                <UniversalButton
                    label="Create report"
                    size="lg"
                    labelColor="white"
                    labelHoverColor="white"
                    backgroundColor="orange"
                    backgroundHoverColor="orange-light"
                    isFullWidth
                    onClick={handleCreateReport}
                />
            </div>

            <ModalComponent
              onCloseModal={handleClosePremiumModal}
              isVisible={isPremiumModalVisible}
            >
              <GoToPremiumModal
                text="<p>Premium version allows you to save templates endlessly, save elements as you wish, and much more.</p>
                <br/>
                <p>Take a look at our site to best understand what the premium upgrade has to offer!</p>"
              />
            </ModalComponent>
        </div>
    );
};

export default SidebarProject;
